import {
	MODULE_NAME,
	VENDOR,
	VENDORS,
	RELOAD_VENDORS,
	SAVE_VENDOR,
	SET_VENDOR,
	SET_VENDOR_BY_CODE,
	SET_VENDORS,
	SHOW_VENDOR_MODAL,
	SHOW_DEPENDENT_VENDOR_MODAL,
	TOAST_MESSAGES_PUSH,
	LOADING,
	ERROR,
	SET_LOADING,
	SET_ERROR,
	DEACTIVATE_VENDOR,
	SAVE_VUENIVERSITY,
	SET_VUENIVERSITY,
	VUENIVERSITY,
	SAVE_CONTACT_VENDOR,
	SET_CONTACTS_VENDOR,
	CONTACTS_VENDOR,
	CONTACT,
	DELETE_CONTACT_VENDOR,
	DEPENDENTS_VENDOR,
	SET_DEPENDENTS_VENDOR,
	LOADED_DEPENDENTS,
	SET_LOADED_DEPENDENTS,
	SHOW_DEALERSHIPCOMPANIES_MODAL,
	SET_DEALERSHIPCOMPANIES,
	DEALERSHIPCOMPANIES,
	TOTAL_CUSTOMERS_COUNT,
	MATCHES,
	SET_MATCHES
} from './vendors-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';
import _ from 'lodash';

const baseApi = `/${MODULE_NAME}`;

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[VENDOR]: null,
		[VENDORS]: {},
		[RELOAD_VENDORS]: false,
		[SHOW_VENDOR_MODAL]: false,
		[SHOW_DEPENDENT_VENDOR_MODAL]: false,
		[SHOW_DEALERSHIPCOMPANIES_MODAL]: false,
		[LOADING]: false,
		[ERROR]: false,
		[CONTACT]: null,
		[CONTACTS_VENDOR]: {},
		[DELETE_CONTACT_VENDOR]: {},
		[DEPENDENTS_VENDOR]: {},
		[LOADED_DEPENDENTS]: false,
		[DEALERSHIPCOMPANIES]: {},
		[TOTAL_CUSTOMERS_COUNT]: 0,
		[MATCHES]: {},
		[VUENIVERSITY]: null
	},
	mutations: {
		// LOADING & ERROR HANDLING
		[SET_LOADING](state, value) {
			state[LOADING] = value;
		},
		[SET_ERROR](state, value) {
			state.error = value;
		},
		[RELOAD_VENDORS](state, value) {
			state[RELOAD_VENDORS] = value;
		},
		[SET_VENDORS](state, obj) {
			state[VENDORS] = obj;
		},
		[SET_VENDOR](state, obj) {
			state[VENDOR] = obj;
			state[SHOW_VENDOR_MODAL] = obj !== null;
		},
		[SET_VUENIVERSITY](state, obj) {
			state[VUENIVERSITY] = obj;
		},
		[SHOW_VENDOR_MODAL](state, value) {
			state[SHOW_VENDOR_MODAL] = value;
		},
		[SHOW_DEPENDENT_VENDOR_MODAL](state, value) {
			state[SHOW_DEPENDENT_VENDOR_MODAL] = value;
		},
		[SHOW_DEALERSHIPCOMPANIES_MODAL](state, value) {
			state[SHOW_DEALERSHIPCOMPANIES_MODAL] = value;
		},
		[DEALERSHIPCOMPANIES](state, value) {
			state[DEALERSHIPCOMPANIES] = value;
		},
		[DEACTIVATE_VENDOR](state, value) {
			state[VENDOR] = value;
		},
		[SET_CONTACTS_VENDOR](state, obj) {
			state[CONTACTS_VENDOR] = obj;
		},
		[SET_DEPENDENTS_VENDOR](state, obj) {
			state[DEPENDENTS_VENDOR] = obj;
		},
		[SET_LOADED_DEPENDENTS](state, value) {
			state[LOADED_DEPENDENTS] = value;
		},
		[SET_DEALERSHIPCOMPANIES](state, obj) {
			state[DEALERSHIPCOMPANIES] = obj;
		},
		[TOTAL_CUSTOMERS_COUNT](state, value) {
			state[TOTAL_CUSTOMERS_COUNT] = value;
		},
		[SET_MATCHES](state, obj) {
			state[MATCHES] = obj;
		},
		[SAVE_VUENIVERSITY](state, value) {
			state[SAVE_VUENIVERSITY] = value;
		},
		[VUENIVERSITY](state, value) {
			state[VUENIVERSITY] = value;
		}
	},
	actions: {
		[SHOW_VENDOR_MODAL]({ commit }, value) {
			commit(SHOW_VENDOR_MODAL, value);
		},
		[SHOW_DEPENDENT_VENDOR_MODAL]({ commit }, value) {
			commit(SHOW_DEPENDENT_VENDOR_MODAL, value);
		},
		[SHOW_DEALERSHIPCOMPANIES_MODAL]({ commit }, value) {
			commit(SHOW_DEALERSHIPCOMPANIES_MODAL, value);
		},
		[DEALERSHIPCOMPANIES]({ commit }, value) {
			commit(DEALERSHIPCOMPANIES, value);
		},
		[TOTAL_CUSTOMERS_COUNT]({ commit }, value) {
			commit(TOTAL_CUSTOMERS_COUNT, value);
		},
		async [SAVE_VENDOR]({ dispatch, commit }, obj) {
			if (!obj.IntegratorTypeId) {
				// assigned Id from db.IntegratorsTypes = 3P Vendor
				obj.IntegratorTypeId = 1;
			}
			let action = 'added';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Integrator successfully ${action}.`
				};
			};
			let result;

			commit(RELOAD_VENDORS, true);
			if (obj.id) {
				action = 'edited';
				await api
					.patch(`${baseApi}/${obj.id}`, obj.data)
					.then(resp => {
						result = { ...resp };
						parseResponse();
					})
					.catch()
					.finally(() => {
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					});
			} else {
				commit(SET_MATCHES, {});
				await api
					.post(`${baseApi}`, obj)
					.then(resp => {
						result = { ...resp };
						parseResponse();
					})
					.catch(error => {
						if (error) {
							messageObj.message = error;
						}
					})
					.finally(() => {
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					});
			}
			commit(SET_VENDOR, result);
			commit(RELOAD_VENDORS, false);
		},
		async loadVendors({ dispatch, commit, state }, params) {
			const { page } = params;
			if (page === 1) {
				commit(SET_VENDORS, {});
			}
			const valuesToRemove = [undefined, '', 'all'];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			return new Promise((resolve, reject) => {
				api.get('/integrators', {
					params
				})
					.then(res => {
						if (_.isEmpty(state[VENDORS])) {
							commit(SET_VENDORS, res);
						} else {
							let currentStore = _.cloneDeep(state[VENDORS]);
							let integratorsPayload = mergePayloadObjects(
								currentStore,
								res
							);
							commit(SET_VENDORS, integratorsPayload);
						}
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async [SET_VENDOR]({ dispatch, commit }, id) {
			commit(SET_LOADING, true);
			let hasResultValue = false;
			await api
				.get(`${baseApi}/${id}`)
				.then(res => {
					commit(SET_VENDOR, res);
					hasResultValue = true;
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					} else {
						messageObj.message = '3P Vendor not found';
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			commit(SET_LOADING, false);
			return hasResultValue;
		},
		async [SET_VENDOR_BY_CODE]({ dispatch, commit }, integratorCode) {
			commit(SET_LOADING, true);
			let hasResultValue = false;
			await api
				.get(`${baseApi}/code/${integratorCode}`)
				.then(res => {
					commit(SET_VENDOR, res);
					hasResultValue = true;
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					} else {
						messageObj.message = '3P Vendor not found';
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			commit(SET_LOADING, false);
			return hasResultValue;
		},
		async [DEACTIVATE_VENDOR]({ dispatch, state, commit }, params) {
			const { id, action } = params;

			const parseResponse = (code, obj) => {
				let returnAction =
					code === 200 ? 'successfully' : 'unsuccessfully';
				messageObj = {
					statusCode: code,
					message: `Integrator ${returnAction} ${action}d.`
				};
				if (code === 200) {
					commit(SET_VENDOR, obj);
				}
			};
			let success = false;
			await api
				.put(`${baseApi}/${id}/${action}`)
				.then(() => {
					let newVendor = _.cloneDeep(state.integrator);
					newVendor.active = !newVendor.active;
					parseResponse(200, newVendor);
					success = true;
				})
				.catch(() => {
					parseResponse(400, {});
				})
				.finally(() => {
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			return success;
		},
		async [SAVE_CONTACT_VENDOR](
			{ dispatch, commit },
			{ contact, action, isPrimaryUpdate }
		) {
			let success = false;

			await api[action](
				`${baseApi}/${contact.integratorId}/contacts/${
					action === 'put' ? contact.id : ''
				}`,
				contact
			)
				.then(res => {
					success = true;
					commit(SET_CONTACTS_VENDOR, res);
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 200,
							message: isPrimaryUpdate
								? 'New contact as primary.'
								: 'Integrator successfully saved.'
						},
						{
							root: true
						}
					);
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: error,
							message: 'Integrator unsuccessfully saved.'
						},
						{
							root: true
						}
					);
					success = false;
				});
			return success;
		},
		async [DELETE_CONTACT_VENDOR]({ dispatch, commit }, obj) {
			const parseResponse = resp => {
				const code = success ? 200 : 400;
				const returnAction = success
					? 'successfully'
					: 'unsuccessfully';
				messageObj = {
					statusCode: code,
					message: `Contact Vendor ${returnAction} removed.`
				};
				if (success) {
					commit(SET_CONTACTS_VENDOR, resp);
				}
			};

			let success = false;
			await api
				.delete(`${baseApi}/${obj.integratorId}/contacts/${obj.id}`)
				.then(res => {
					success = true;
					commit(SET_CONTACTS_VENDOR, {});
					parseResponse(res);
				})
				.catch(() => {
					parseResponse({});
				})
				.finally(() => {
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
			return success;
		},
		async [SET_CONTACTS_VENDOR]({ commit }, id) {
			if (!id) {
				commit(SET_CONTACTS_VENDOR, {});
				return;
			}
			let success = false;
			let results;
			await api.get(`${baseApi}/${id}/contacts`).then(res => {
				success = true;
				results = { ...res };
			});

			commit(SET_CONTACTS_VENDOR, results);
			return success;
		},
		async [SET_DEPENDENTS_VENDOR]({ commit }, params) {
			const { integratorId: id, search } = params;

			let results;
			await api.get(`${baseApi}/${id}/dependents`, search).then(res => {
				results = { ...res };
				commit(SET_LOADED_DEPENDENTS, true);
			});
			commit(SET_DEPENDENTS_VENDOR, results);
		},
		async [SET_DEALERSHIPCOMPANIES]({ commit }, parameters) {
			let success = false;
			let results;

			commit(SET_DEALERSHIPCOMPANIES, {});

			await api
				.get(
					buildRoute(
						`${baseApi}/${parameters.integratorId}/customers`,
						parameters
					)
				)
				.then(res => {
					success = true;
					results = { ...res };
				});

			commit(SET_DEALERSHIPCOMPANIES, results);
			return success;
		},
		async [SET_MATCHES]({ commit }, params) {
			commit(SET_MATCHES, {});
			const results = await api.get(
				buildRoute(`${baseApi}/matches`, params)
			);
			commit(SET_MATCHES, results);
			if (results.items.length) {
				return true;
			}
			return false;
		},
		async [SAVE_VUENIVERSITY]({ commit, dispatch }, parameters) {
			let success = true;
			commit(SET_VUENIVERSITY, {});
			await api
				.put(`${baseApi}/${parameters.id}/vueniversity`, parameters)
				.then(resp => {
					commit(SET_VUENIVERSITY, resp);
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: error,
							message: 'URLVueniversity unsuccessfully saved.'
						},
						{
							root: true
						}
					);
					success = false;
				});

			return success;
		}
	},
	getters: {
		[VENDOR]: state => state[VENDOR],
		[VENDORS]: state => state[VENDORS],
		[RELOAD_VENDORS]: state => state[RELOAD_VENDORS],
		[SHOW_VENDOR_MODAL]: state => state[SHOW_VENDOR_MODAL],
		[SHOW_DEPENDENT_VENDOR_MODAL]: state =>
			state[SHOW_DEPENDENT_VENDOR_MODAL],
		/// CONTACT
		[CONTACT]: state => state[CONTACT],
		[CONTACTS_VENDOR]: state => state[CONTACTS_VENDOR],
		/// DEPENDENTS
		[DEPENDENTS_VENDOR]: state => state[DEPENDENTS_VENDOR],
		[LOADED_DEPENDENTS]: state => state[LOADED_DEPENDENTS],
		// Dealership
		[SHOW_DEALERSHIPCOMPANIES_MODAL]: state =>
			state[SHOW_DEALERSHIPCOMPANIES_MODAL],
		[DEALERSHIPCOMPANIES]: state => state[DEALERSHIPCOMPANIES],
		[TOTAL_CUSTOMERS_COUNT]: state => state[TOTAL_CUSTOMERS_COUNT],
		[LOADING]: state => state[LOADING],
		/// Matches
		[MATCHES]: state => state[MATCHES],
		[VUENIVERSITY]: state => state[VUENIVERSITY]
	}
};
